import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";

class ConfirmationDialogRaw extends React.Component {
	constructor(props) {
		super();
		this.state = {
			value: props.options[0].text ? props.options[0].value : props.options[0],
			options: props.options
		};
	}

	// TODO
	componentWillReceiveProps(nextProps) {
		if (nextProps.options !== this.props.options) {
			this.setState({
				value: nextProps.options[0],
				options: nextProps.options
			});
		}
	}

	handleEntering = () => {
		this.radioGroupRef.focus();
	};

	handleCancel = () => {
		this.props.onClose(this.props.value, this.props.activename, "cancel");
	};

	handleOk = () => {
		this.props.onClose(this.state.value, this.props.activename, "ok");
	};

	handleChange = (event, value) => {
		//console.log(value);
		this.setState({ value });
	};

	render() {
		const { value, ...other } = this.props;

		return (
			<Dialog
				disableBackdropClick
				disableEscapeKeyDown
				maxWidth="xs"
				onEntering={this.handleEntering}
				aria-labelledby="confirmation-dialog-title"
				{...other}>
				<DialogTitle id="confirmation-dialog-title">{this.props.title || "modal"}</DialogTitle>
				<DialogContent>
					<RadioGroup
						ref={(ref) => {
							this.radioGroupRef = ref;
						}}
						aria-label="List of services"
						name="uslugi"
						value={this.state.value}
						onChange={this.handleChange}>
						{this.state.options.map((option) => (
							<FormControlLabel
								value={option.text ? option.value : option}
								key={option.text ? option.value : option}
								control={<Radio />}
								label={
									option.text ? (
										this.props.langbase.il9n[option.text]
									) : (
										option + " " + this.props.langbase.il9n.unit
									)
								}
							/>
						))}
					</RadioGroup>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleCancel} color="primary">
						Cancel
					</Button>
					<Button onClick={this.handleOk} color="primary">
						Ok
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmationDialogRaw.propTypes = {
	onClose: PropTypes.func,
	value: PropTypes.string
};

const styles = (theme) => ({
	root: {
		width: "100%",
		maxWidth: 360,
		margin: "0 auto"
	},
	paper: {
		width: "80%",
		maxHeight: 435
	}
});

const mapStateToProps = (state) => ({
	langbase: state.langBase
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ConfirmationDialogRaw));
